import { Component, HostListener } from '@angular/core';
import { DataServiceService } from '../../service/data-service.service';

interface BuildInfo {
  version: string;
  commitSha: string | null;
  commitShaShort: string | null;
  branch: string | null;
  buildDate: string | null;
  env: string;
}

@Component({
  selector: 'app-version-info',
  standalone: true,
  imports: [],
  templateUrl: './version-info.component.html',
  styleUrl: './version-info.component.scss',
})
export class VersionInfoComponent {
  isOpen = false;
  loaded = false;

  frontendInfo: BuildInfo | null = null;
  backendInfo: BuildInfo | null = null;

  constructor(private dataService: DataServiceService) {}

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    if (this.isOpen && !this.loaded) this.load();
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.isOpen = false;
  }

  private load(): void {
    this.loaded = true;

    fetch('/version.json')
      .then(res => (res.ok ? res.json() : null))
      .then(data => (this.frontendInfo = data))
      .catch(() => (this.frontendInfo = null));

    this.dataService.getVersion().subscribe({
      next: data => (this.backendInfo = data),
      error: () => (this.backendInfo = null),
    });
  }

  formatDate(dateStr: string | null): string {
    if (!dateStr) return 'no disponible';
    return new Date(dateStr).toLocaleString('es', {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  }
}
